import React from "react";
import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import App from "./App";
import "./index.scss";
import { BrowserRouter } from 'react-router-dom';

const root = createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
